import { all, call, put, takeEvery } from 'redux-saga/effects'
import { globalLoaderText } from "redux/CommonDashboard/actions";
import OrganizationApiService from './OrganizationApiService';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';
import { GET_REGION_DROP_DOWN_LIST } from 'Store/Organization/Region/RegionType';
import { setRegionDropDown } from 'Store/Organization/Region/RegionAction';

function* getRegionsList(req: any): any {
    try {
        yield put(globalLoaderText("Fetching Dropdown Data...."));
        let payloadData: IPayload = {
            apiType: apiType.Organization,
            endpoint: `organizations/structure/dropdown/region`,
            apiMethod: apiMethod.GET,
            payload: null

        }
        const response = yield call(
            OrganizationApiService.post, API_URL.PostWebApp, payloadData
        );
        yield put(setRegionDropDown(response));
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(setRegionDropDown([]));
        yield put(globalLoaderText(""));
    }
}

function* watchGetRegionDropDowns() {
    yield takeEvery(GET_REGION_DROP_DOWN_LIST, getRegionsList)
}

export default function* combinedSaga() {
    yield all([
        watchGetRegionDropDowns()
    ])
}
